jQuery(function() {
        
    jQuery(document).on( 'nfFormReady', function( e, layoutView ) {

        const formId = jQuery('.questionnaire-container .nf-form-cont').attr('id').replace(/nf-form-([0-9]+)-cont/g, "$1");

        let isComplete = false;

        $document = jQuery(document);

        $document.on('click', '.nf-help-text button', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();

            jQuery(this).parent().find('.nf-help-text-container').toggleClass('hidden');
            jQuery(this).find('.question-mark').toggleClass('hidden');
            jQuery(this).find('.times').toggleClass('hidden');
        });

        $document.on('keypress', 'input, select', function (evt) {
            if(evt.keyCode == 13){
                evt.preventDefault();
                jQuery(this).trigger('blur');
                jQuery('.nf-next').trigger('click');
            }   
        });

        $document.on('click','.list-select-wrap .nf-field-element', function () {
            $(this).find('select').trigger('mousedown, touchstart');
        });

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        var BarSection = '';
        var gradientClass;
        var $links = $('#menu-section-menu').find('li');
        var currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        var $bar = $('.bar');

        const formIds = ['3','4','5','6','7','8','9','10'];

        let forms = JSON.parse(window.localStorage.getItem('completed'));

        if (!forms) {
            forms = [];
        }

        if (forms.indexOf(formId) >= 0) {
            isComplete = true;
        }

        let percentageComplete = 0;

        let formPercentages = []; 
        formPercentages[3] = {'percentage' : 6, 'questions': 7};
        formPercentages[4] = {'percentage' : 34, 'questions': 34};
        formPercentages[5] = {'percentage' : 10, 'questions': 26};
        formPercentages[6] = {'percentage' : 8, 'questions': 3};
        formPercentages[7] = {'percentage' : 8, 'questions': 3};
        formPercentages[8] = {'percentage' : 13, 'questions': 5};
        formPercentages[9] = {'percentage' : 8, 'questions': 4};
        formPercentages[10] = {'percentage' : 13, 'questions': 5};


        $links.each(function(item) {

            var active = (currentUrl == $(this).find('a').attr('href')) ? 'active' : '';
            var tooltipText = '<span>' + $(this).find(".section-number").text() + ':</span> ' + $(this).find(".link-title").text();
            var oldurl = $(this).find('a').attr('href');
            var dataHref = (params.user != '' && params.user != null) ? oldurl + '?user=' + params.user : oldurl;
            var dataHref = (params.appid != '' && params.appid != null) ? dataHref + '&appid=' + params.appid : oldurl;

            if (active) {
                gradientClass = 'gradient-' + item;
            }

            let linkable = false;

            if (forms.indexOf(formIds[item]) >= 0) {
                
                percentageComplete = percentageComplete + formPercentages[formIds[item]].percentage;
                $(this).addClass('completed');
                $(this).find('a').attr('href', dataHref);
                linkable = true;

            }
            else if (!$(this).hasClass('current_page_item'))  {
                $(this).addClass('disabled');
                $(this).find('a').attr('href', "#");
                linkable = false;
            }

            if (item < 8) {
                if (linkable || active) {
                    BarSection += '<div class="bar-section ' + active + '" data-href="' + dataHref + '"><div class="tooltip hidden">' + tooltipText + '</div></div>';
                }
                else {
                    BarSection += '<div class="bar-section ' + active + ' disabled " data-href="#"><div class="tooltip hidden">' + tooltipText + '</div></div>';
                }
                
            }

            if (active) {
                //only add what we are up to.
                percentageComplete += 1;
            }
        });

        function barPercentageUpdate(addToPercentage) {
            percentageComplete += addToPercentage;
            const gradiantStyle = `linear-gradient(to right, #949536  ${percentageComplete}%, #EAEAEA 0%,#EAEAEA 100%)`;
            
            $bar.css('background', gradiantStyle);
            $bar.html(BarSection);
        }

        nfRadio.channel( 'nfMP' ).on( 'change:part', function($) {
            if (isComplete === false) {
                const updateAmount = formPercentages[formId].percentage / formPercentages[formId].questions;
                barPercentageUpdate(updateAmount);
            }
            
        });

        barPercentageUpdate(1);

        $('.bar-section').on('mouseover', function() {
            $(this).find('.tooltip').removeClass('hidden');
        }).on('mouseout', function() {
            $(this).find('.tooltip').addClass('hidden');
        });

        $('.bar-section').on('click', function() {
            window.location.href = $(this).data('href');
        });

        var $clearform = jQuery('.clear-form a');
        var $saveform = jQuery('.save-progress a');
        var $startOver = jQuery('.start-over a');

        $clearform.on('click', function(e) {
            e.preventDefault();

            if (isComplete) {

                for (var key in forms) {
                    if (forms[key] == formId) {
                        forms.splice(key, 1);
                    }
                }
                window.localStorage.setItem('completed', JSON.stringify(forms));
            }
            window.location.reload();
        });

        $saveform.on('click', function(e) {
            $('.save-container .nf-submit').click();

            window.location.reload();
        });

        $startOver.on('click', function(e) {
            window.localStorage.clear();
        });

        
    });

    function helpTextRemoveClass() {
      document.querySelectorAll('.nf-help-text').forEach((item, i) => {
        if (item.dataset.content != "") {
          item.classList.remove("hidden");
        }
      });
    }

    // Select the node that will be observed for mutations
    const targetNode = document.querySelector('.nf-form-cont');

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationList, observer) {
        // Use traditional 'for loops' for IE 11
        for(const mutation of mutationList) {
            if (mutation.type === 'childList') {
                if (document.querySelectorAll('.submit-container')[0] != null) {
                    addSubmit();
                } else {
                    removeSubmit();
                }

                helpTextRemoveClass();
            }
            else if (mutation.type === 'attributes') {
                if (mutation.attributeName == 'class') {
                    if (document.querySelectorAll('.submit-container')[0] != null) {
                        addSubmit();
                    } else {
                        removeSubmit();
                    }
                }
            }
            
        }
    };

    const addSubmit = function() {
        var $submit = jQuery('.submit-container .submit-wrap');
        
        $submit.appendTo('.nf-mp-footer');
    }

    const removeSubmit = function() {
        $('.nf-mp-footer .submit-wrap').parent().remove();
    }

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    if (targetNode != null) {
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }


    if (typeof Marionette !== 'undefined') {
        var recordCompleted = Marionette.Object.extend( {
      
            initialize: function() {
                this.listenTo( Backbone.Radio.channel( 'forms' ), 'submit:response', this.actionSubmit );
            },

            actionSubmit: function( response ) {

                if (response.errors.length === 0) {
                    
                    let forms = JSON.parse(window.localStorage.getItem('completed'));
                    
                    if (forms === null) {
                        forms = [];
                    }

                    forms.push(response.data.form_id);
                    window.localStorage.setItem('completed', JSON.stringify(forms));
                }
            },

        });


        new recordCompleted();
    }
});
